import { render, staticRenderFns } from "./PromotionTeam.vue?vue&type=template&id=1671688e&scoped=true"
import script from "./PromotionTeam.vue?vue&type=script&lang=js"
export * from "./PromotionTeam.vue?vue&type=script&lang=js"
import style0 from "./PromotionTeam.vue?vue&type=style&index=0&id=1671688e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1671688e",
  null
  
)

export default component.exports